export const PROOF_LINK_ERROR_CODES = [
  'proof_link_invalid',
  'proof_link_unavailable',
] as const;

export type ProofLinkErrorCode = (typeof PROOF_LINK_ERROR_CODES)[number];

const PROOF_LINK_ERROR_MESSAGES: Record<ProofLinkErrorCode, string> = {
  proof_link_invalid: 'Proof links are invalid. Refresh proof selections and try again.',
  proof_link_unavailable:
    'Proof links changed or are no longer eligible. Refresh proof selections, remove blocked links, and try again.',
};

export class ProofLinkWriteError extends Error {
  readonly code: ProofLinkErrorCode;

  constructor(code: ProofLinkErrorCode) {
    super(PROOF_LINK_ERROR_MESSAGES[code]);
    this.name = 'ProofLinkWriteError';
    this.code = code;
  }
}

function readErrorMessage(error: unknown): string {
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message;
    return typeof message === 'string' ? message : '';
  }
  return '';
}

export function normalizeProofLinkWriteError(error: unknown): ProofLinkWriteError | null {
  const message = readErrorMessage(error);
  const code = PROOF_LINK_ERROR_CODES.find((candidate) => message.includes(candidate));
  return code ? new ProofLinkWriteError(code) : null;
}
